import React, { useState, useEffect, useCallback, useRef } from 'react';

import { useHistory } from 'react-router-dom';
import { RiBankFill } from 'react-icons/ri';
import { MdSearch } from 'react-icons/md';
import { IPaginate } from 'shared/interfaces';
import { useToast } from 'contexts';
import { ModalHandles } from 'components/Modal';

import * as C from 'components';
import * as S from './styles';

import { getUnits, deleteUnit } from '../api';
import { IUnit } from '../interfaces';

export const UnitList: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();
  const [units, setUnits] = useState<IPaginate<IUnit>>();
  const [unitAtual, setUnitAtual] = useState<IUnit>();
  const [loading, setLoading] = useState(false);
  const [term, setTerm] = useState('');
  const modalRemoverRef = useRef<ModalHandles>(null);

  const handleSearch = useCallback(
    ({ page, per_page }) => {
      setLoading(true);

      const params = {
        page,
        per_page,
        term,
      };

      getUnits(params)
        .then((data) => {
          setUnits(data);

          setLoading(false);
        })
        .catch((e) => {
          addToast({
            type: 'error',
            title: 'Ops, Erro',
            description: e.response?.data?.message,
          });

          setLoading(false);
        });
    },
    [addToast, term],
  );

  useEffect(() => {
    const params = {
      page: 1,
      per_page: 20,
    };

    handleSearch(params);
  }, [handleSearch]);

  const handleRemove = async (): Promise<void> => {
    try {
      await deleteUnit(unitAtual!.id);

      if (!units) return;

      const newList = units.data.filter((item) => item.id !== unitAtual?.id);
      setUnits({ ...units, data: newList });

      modalRemoverRef.current?.closeModal();

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Registro removido com sucesso',
      });
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ops, Erro',
        description: 'Ocorreu um erro ao remover o registro',
      });
    }
  };

  const handleOpenModalRemover = useCallback((roleSelected: IUnit): void => {
    setUnitAtual(roleSelected);
    modalRemoverRef.current?.openModal();
  }, []);

  return (
    <S.Container>
      <C.HeaderBackground>
        <C.HeaderPage>
          <C.HeaderInfo title="Unidades" icon={RiBankFill} />

          <S.ContainerSearch>
            <C.InputSearch
              title="Digite aqui o que deseja pesquisar"
              icon={MdSearch}
              placeholder="Pesquisar"
              onChange={(e) => setTerm(e.target.value)}
              onKeyDown={(e) => {
                e.key === 'Enter'
                  ? handleSearch({ page: 1, per_page: units?.per_page })
                  : {};
              }}
            />
          </S.ContainerSearch>

          <div>
            <C.Can checkAccess="units_create">
              <C.ButtonLink title="Adicionar unidade" to="/units/new">
                Adicionar
              </C.ButtonLink>
            </C.Can>
          </div>
        </C.HeaderPage>
      </C.HeaderBackground>

      <S.Panel>
        {loading ? (
          <C.Loader loading={loading} align="center" message="Carregando..." />
        ) : (
          <>
            <div className="tbl-content">
              <C.Table>
                <thead>
                  <tr>
                    <th className="text-center">Foto</th>
                    <th className="text-left">Descrição</th>
                    <th className="text-left">Login</th>
                    <th className="text-center">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {units &&
                    units.data.map((item: IUnit) => (
                      <tr key={item.id}>
                        <td className="text-center">
                          <C.Image
                            roundedCircle
                            height="80"
                            width="80"
                            src={item.image_url}
                            alt={item.name}
                          />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.login}</td>
                        <td className="text-center">
                          <C.PopUpMenu>
                            <C.Can checkAccess="units_update">
                              <button
                                type="button"
                                onClick={() =>
                                  history.push(`/units/edit/${item.id}`)
                                }
                              >
                                <S.IconEdit
                                  title="Editar"
                                  size={24}
                                  color="#707070"
                                />
                                Editar
                              </button>
                            </C.Can>

                            <C.Can checkAccess="units_delete">
                              <button
                                type="button"
                                onClick={() => handleOpenModalRemover(item)}
                              >
                                <S.IconDelete
                                  title="Remover"
                                  size={24}
                                  color="#707070"
                                />
                                Remover
                              </button>
                            </C.Can>
                          </C.PopUpMenu>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </C.Table>
            </div>
          </>
        )}
        <S.PaginationContainer>
          {units && (
            <C.Pagination
              page={units?.page}
              total={units?.total}
              per_page={units?.per_page}
              last_page={units?.last_page}
              onSearch={handleSearch}
            />
          )}
        </S.PaginationContainer>
      </S.Panel>

      <C.Modal ref={modalRemoverRef} options={{ width: '400px' }}>
        <C.ModalHeader>
          <C.ModalTitle>Você Confirma a EXCLUSÃO?</C.ModalTitle>
        </C.ModalHeader>
        <C.ModalBody>
          <p>O registro será removido completamente!</p>
        </C.ModalBody>
        <C.ModalFooter>
          <C.Position align="right">
            <C.Button
              variant="outline-secondary"
              onClick={() => modalRemoverRef.current?.closeModal()}
            >
              Cancelar
            </C.Button>
            <C.Button
              variant="primary"
              onClick={() => handleRemove()}
              style={{ marginLeft: '16px' }}
            >
              SIM, confirmo a exclusão
            </C.Button>
          </C.Position>
        </C.ModalFooter>
      </C.Modal>
    </S.Container>
  );
};
